export const Deals = () => {
  return (
    <div className="container" style={{ paddingTop: '24px' }}>
      <h1>Акции</h1>
      <p>Список акций и специальных предложений...</p>
    </div>
  );
};